import React from "react";
import './Registry.css';
import { Container, Card, Row, Col} from "react-bootstrap";

const Registry = () => {
    return (
        <div class="registry text-center container-styling">
            <div class="title-padding top-header">
                <h1>Registry</h1>
            </div>
            <Container className="py-5">
            <Row className="row-cols-1">
                <Col className="d-flex justify-content-center">
                    <Card style={{ width: '18rem' }}>
                        <a 
                                href="https://prezola.com/buy/view/236139" 
                                target="_blank" 
                                rel="noopener noreferrer"
                            >
                            <Card.Img variant="top" src="../registry-compressed.png" />
                        </a>
                        <Card.Body>
                            <Card.Title>
                                    <a 
                                        href="https://prezola.com/buy/view/236139" 
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Gift registry
                                    </a>
                            </Card.Title>
                            <Card.Text>
                                We are registered at Prezola.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            </Container>
        </div>
        
    );
}

export default Registry;